<template lang="pug">
  #CustomerUsersModel.CustomerModel.CustomerModel-usersModel.p-3(
    :class="{ 'CustomerModel-active': showModel }"
  )
    .row.align-items-start.mb-2
      .col-10
      .col-2
        img.rounded-circle.closeIcon(
          v-lazy="iconUrl.IconClose",
          fluid,
          alt="Close Icon",
          @click="closeModel()"
        )
    .title.font-weight-bold.text-center 個資蒐集、處理及利用告知事項
    .line-text-header.mb-2.mt-2.text-center
      .title.font-weight-bold 為了保護您個人資料，僅依個人資料保護法第 8條規定告知以下事項：
    .content.py-2(style='max-height: 350px; overflow: scroll')
      .line-text-header.mb-2
      .line-text-body.py-2.text-justify
        ul.pl-4
          li 蒐集公司：香港商心連天地有限公司台灣分公司及其關係企業(以下簡稱華敦集團)。
          li 蒐集目的：華敦集團中華民國境內外各相關企業之活動參與、身份確認、客戶管理、提供服務、聯絡通知、行銷、市場推廣、統計、調查、研究等。
          li 個人資料類別：中英文姓名、性別、生日、年齡、職業、通訊、E-mail、地址及其他得以直接或間接識別本人之資料。
          li 個人資料利用期間：華敦營運期間。
          li 個人資料利用地區：中華民國境內外地區
          li 利用對象及方式：您的個人資料將由華敦集團及受華敦集團委託之第三方合作廠商(包括但不限於與中介代理、承辦商、EC與第三方認證業者如google、 Facebook、Apple、Line等，或提供行政、電訊、數據處理、電腦支援或客戶服務等的第三方服務商)在蒐集目的之範圍內予以利用。
          li 您享有個資法之權利：查詢或請求閱覽、請求製給複製本、請求補充或更正、請求停止蒐集、處理及利用、請求刪除。上述有關個人資料之查詢或更正，或個資之閱覽、製給複製本、停止或刪除等部份、華敦集團只接受以書面方式通知後，再行政處理之。惟華敦執行職務或業務必須者，得不予停止或刪除。
          li 若您未能提供個人資料，將無法享有華敦相關服務。
    div(style='border-top: 1px solid #ccc;')
</template>

<script>
import { mapState } from 'vuex';
import IconCloseUrl from '@/assets/images/icon/icon_close.png';

const _ = require('lodash');

export default {
  name: 'NoticeModel',
  props: {},
  components: {},
  data() {
    return {
      iconUrl: {
        IconClose: IconCloseUrl
      },
      showModel: false,
    };
  },
  mounted() {
    const vm = this;
    this.$EventBus.$on('openNoticeModel', () => {
      vm.openModel();
    });
  },
  methods: {
    initHandler() {
      const vm = this;
      vm.openModel();
    },
    openModel() {
      this.showModel = true;
    },
    closeModel() {
      this.showModel = false;
    },
  },
  computed: {
    ...mapState({}),
  },
  beforeDestroy() {
    this.$EventBus.$off('openUsersModel');
  }
};
</script>

<style>

</style>
